import React from "react";
import { color } from "..";
import { CheckboxBlankCircleFill } from "../IconV2/react";

type ValidityDotProps = {
  state?: "pending" | "warning" | "success" | "error" | "info";
};

export const stateColorMap: Record<NonNullable<ValidityDotProps["state"]>, string> = {
  pending: color.raw.titanium600,
  warning: color.raw.phosphorus400,
  success: color.raw.chlorine600,
  error: color.raw.oxygen400,
  info: color.raw.lightNitrogen500_Main,
};

const ValidityDot = ({
  state = "pending",
  className,
  ...props
}: React.ComponentProps<typeof CheckboxBlankCircleFill> & ValidityDotProps) => (
  <CheckboxBlankCircleFill
    size="xxs"
    color={stateColorMap[state]}
    data-cy="validity-dot"
    className={className}
    {...props}
  />
);

export default ValidityDot;
